
import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_CURATOR_OFFERS,
  GET_OPERATION_OFFERS,
  GET_APPROVER_OFFERS,
  GET_PUBLISHED_OFFERS,
  MANAGE_CURATOR_OFFER,
  MANAGE_OPERATION_OFFER,
  MANAGE_PUBLISHED_OFFER,
  GET_OFFER_TAGS,
  MANAGE_OFFER_TAG,
  GET_OFFER_TAG_DEFINITIONS,
  GET_OFFER_INCLUSIONS,
  MANAGE_OFFER_INCLUSIONS,
  GET_OFFER_EXCLUSIONS,
  MANAGE_OFFER_EXCLUSIONS,
  GET_OFFER_TERMS_CONDITIONS,
  MANAGE_OFFER_TERMS_CONDITIONS,
  POST_OFFER,
  REJECT_OFFER,
  PROCESS_OFFER,
  PUBLISH_OFFER,
  DENY_OFFER,
} from "./actionTypes"

import {
  getCuratorOffers as onGetCuratorOffers,
  getCuratorOffersSuccess,
  getCuratorOffersFail,
  getOperationOffers as onGetOperationOffers,
  getOperationOffersSuccess,
  getOperationOffersFail,
  getApproverOffers as onGetApproverOffers,
  getApproverOffersSuccess,
  getApproverOffersFail,
  getPublishedOffersSuccess,
  getPublishedOffersFail,
  manageCuratorOfferSuccess,
  manageCuratorOfferFail,
  manageOperationOfferSuccess,
  manageOperationOfferFail,
  managePublishedOfferSuccess,
  managePublishedOfferFail,
  getOfferTagsSuccess,
  getOfferTagsFail,
  manageOfferTagsSuccess,
  manageOfferTagsFail,
  getOfferTags,
  getOfferTagDefinitionsSuccess,
  getOfferTagDefinitionsFail,
  getOfferInclusionsSuccess,
  getOfferInclusionsFail,
  manageOfferInclusionsSuccess,
  manageOfferInclusionsFail,
  getOfferExclusionsSuccess,
  getOfferExclusionsFail,
  manageOfferExclusionsSuccess,
  manageOfferExclusionsFail,
  getOfferTermsConditionsSuccess,
  getOfferTermsConditionsFail,
  manageOfferTermsConditionsSuccess,
  manageOfferTermsConditionsFail,
  getOfferStateHistorySuccess,
  getOfferStateHistoryFail,
  postOfferSuccess,
  postOfferFail,
  rejectOfferSuccess,
  rejectOfferFail,
  processOfferSuccess,
  processOfferFail,
  publishOfferSuccess,
  publishOfferFail,
  denyOfferSuccess,
  denyOfferFail,
} from "./actions"

import {
  getCuratorOffers,
  getOperationOffers,
  getApproverOffers,
  getPublishedOffers,
  manageCuratorOffer,
  manageOperationsOffer,
  managePublishedOffer,
  getOfferTags as getOfferTagsAPI,
  manageOfferTags,
  getOfferTagDefinitions,
  getOfferInclusions,
  manageOfferInclusions,
  getOfferExclusions,
  manageOfferExclusions,
  getOfferTermsConditions,
  manageOfferTermsConditions,
  getOfferStateHistory,
  postOffer as postOfferAPI,
  rejectOffer as rejectOfferAPI,
  processOffer as processOfferAPI,
  publishOffer as publishOfferAPI,
  denyOffer as denyOfferAPI,
} from "../../helpers/backend_helper"
import { GET_OFFER_STATE_HISTORY } from "helpers/url_helper"

// CURATOR OFFERS SAGAS
function* fetchCuratorOffers({ payload: { options } }) {
  try {
    const response = yield call(getCuratorOffers, options)
    yield put(getCuratorOffersSuccess(response))
  } catch (error) {
    yield put(getCuratorOffersFail(error))
  }
}

function* onManageCuratorOffer({ payload: { offer } }) {
  try {
    // Extract refreshPagination before API call to avoid sending it to backend
    const { refreshPagination, ...offerData } = offer
    const response = yield call(manageCuratorOffer, offerData, {})
    yield put(manageCuratorOfferSuccess(response))

    // Refresh the curator offers list after successful delete using pagination from offer
    if (offer.actionType === "delete") {
      const pagination = refreshPagination || {}
      try {
        const refreshResponse = yield call(getCuratorOffers, {
          headers: { "input-parameters": pagination.inputParams || {} },
          pagination: { startIndex: pagination.startIndex ?? 0 },
        })
        yield put(getCuratorOffersSuccess(refreshResponse))
      } catch (refreshError) {
        if (refreshError.message === "No content available") {
          yield put(getCuratorOffersSuccess([]))
        } else {
          yield put(getCuratorOffersFail(refreshError))
        }
      }
    }
  } catch (error) {
    yield put(manageCuratorOfferFail(error))
  }
}

// OPERATION OFFERS SAGAS
function* fetchOperationOffers({ payload: { options } }) {
  try {
    const response = yield call(getOperationOffers, options)
    yield put(getOperationOffersSuccess(response))
  } catch (error) {
    yield put(getOperationOffersFail(error))
  }
}

function* onManageOperationOffer({ payload: { offer } }) {
  try {
    // Extract refreshPagination before API call to avoid sending it to backend
    const { refreshPagination, ...offerData } = offer
    const response = yield call(manageOperationsOffer, offerData, {})
    yield put(manageOperationOfferSuccess(response))

    // Refresh the operation offers list after successful delete using pagination from offer
    if (offer.actionType === "delete") {
      const pagination = refreshPagination || {}
      try {
        const refreshResponse = yield call(getOperationOffers, {
          headers: { "input-parameters": pagination.inputParams || {} },
          pagination: { startIndex: pagination.startIndex ?? 0 },
        })
        yield put(getOperationOffersSuccess(refreshResponse))
      } catch (refreshError) {
        if (refreshError.message === "No content available") {
          yield put(getOperationOffersSuccess([]))
        } else {
          yield put(getOperationOffersFail(refreshError))
        }
      }
    }
  } catch (error) {
    yield put(manageOperationOfferFail(error))
  }
}

// APPROVER OFFERS SAGAS
function* fetchApproverOffers({ payload: { options } }) {
  try {
    const response = yield call(getApproverOffers, options)
    yield put(getApproverOffersSuccess(response))
  } catch (error) {
    yield put(getApproverOffersFail(error))
  }
}

// PUBLISHED OFFERS SAGAS
function* fetchPublishedOffers({ payload: { options } }) {
  try {
    const response = yield call(getPublishedOffers, options)
    yield put(getPublishedOffersSuccess(response))
  } catch (error) {
    yield put(getPublishedOffersFail(error))
  }
}

function* onManagePublishedOffer({ payload: { offer } }) {
  try {
    const response = yield call(managePublishedOffer, offer, {})
    yield put(managePublishedOfferSuccess(response))
    
    // Refresh the published offers list after successful update
    if (offer.actionType === "delete") {
      yield put(onGetPublishedOffers({
        headers: { "input-parameters": {} },
        pagination: { startIndex: 0 }
      }))
    }
  } catch (error) {
    yield put(managePublishedOfferFail(error))
  }
}

// OFFER TAGS SAGAS
function* fetchOfferTags({ payload: { options } }) {
  try {
    const response = yield call(getOfferTagsAPI, options)
    yield put(getOfferTagsSuccess(response))
  } catch (error) {
    yield put(getOfferTagsFail(error))
  }
}

function* onManageOfferTag({ payload: { data, history } }) {
  try {
    const response = yield call(manageOfferTags, data, {})
    yield put(manageOfferTagsSuccess(response))

    // Refresh offer tags after successful management
    yield put(getOfferTags({
      headers: {
        "input-parameters": { offerID: data.offerID },
      },
    }))

  } catch (error) {
    yield put(manageOfferTagsFail(error))
  }
}

// OFFER TAG DEFINITIONS SAGAS
function* fetchOfferTagDefinitions({ payload: { options } }) {
  try {
    const response = yield call(getOfferTagDefinitions, options)
    yield put(getOfferTagDefinitionsSuccess(response))
  } catch (error) {
    yield put(getOfferTagDefinitionsFail(error))
  }
}

// OFFER INCLUSIONS SAGAS
function* fetchOfferInclusions({ payload: { options } }) {
  try {
    const response = yield call(getOfferInclusions, options)
    yield put(getOfferInclusionsSuccess(response))
  } catch (error) {
    yield put(getOfferInclusionsFail(error))
  }
}

function* onManageOfferInclusions({ payload: { inclusions } }) {
  try {
    const response = yield call(manageOfferInclusions, inclusions, {})
    yield put(manageOfferInclusionsSuccess(response))
  } catch (error) {
    yield put(manageOfferInclusionsFail(error))
  }
}

// OFFER EXCLUSIONS SAGAS
function* fetchOfferExclusions({ payload: { options } }) {
  try {
    const response = yield call(getOfferExclusions, options)
    yield put(getOfferExclusionsSuccess(response))
  } catch (error) {
    yield put(getOfferExclusionsFail(error))
  }
}

function* onManageOfferExclusions({ payload: { exclusions } }) {
  try {
    const response = yield call(manageOfferExclusions, exclusions, {})
    yield put(manageOfferExclusionsSuccess(response))
  } catch (error) {
    yield put(manageOfferExclusionsFail(error))
  }
}

// OFFER TERMS & CONDITIONS SAGAS
function* fetchOfferTermsConditions({ payload: { options } }) {
  try {
    const response = yield call(getOfferTermsConditions, options)
    yield put(getOfferTermsConditionsSuccess(response))
  } catch (error) {
    yield put(getOfferTermsConditionsFail(error))
  }
}

function* onManageOfferTermsConditions({ payload: { termsConditions } }) {
  try {
    const response = yield call(manageOfferTermsConditions, termsConditions, {})
    yield put(manageOfferTermsConditionsSuccess(response))
  } catch (error) {
    yield put(manageOfferTermsConditionsFail(error))
  }
}

function* fetchOfferStateHistory({ payload: { options } }) {
  try {
    const response = yield call(getOfferStateHistory, options)
    yield put(getOfferStateHistorySuccess(response))
  } catch (error) {
    yield put(getOfferStateHistoryFail(error))
  }
}

// OFFER ACTION SAGAS
function* onPostOffer({ payload: { payload } }) {
  try {
    // Extract refreshPagination before API call to avoid sending it to backend
    const { refreshPagination, ...payloadData } = payload
    const response = yield call(postOfferAPI, payloadData)
    yield put(postOfferSuccess(response))

    // Refresh curator offers list using pagination from payload
    const pagination = refreshPagination || {}
    try {
      const refreshResponse = yield call(getCuratorOffers, {
        headers: { "input-parameters": pagination.inputParams || {} },
        pagination: { startIndex: pagination.startIndex ?? 0 },
      })
      yield put(getCuratorOffersSuccess(refreshResponse))
    } catch (refreshError) {
      if (refreshError.message === "No content available") {
        yield put(getCuratorOffersSuccess([]))
      } else {
        yield put(getCuratorOffersFail(refreshError))
      }
    }
  } catch (error) {
    yield put(postOfferFail(error))
  }
}

function* onRejectOffer({ payload: { payload } }) {
  try {
    // Extract refreshPagination before API call to avoid sending it to backend
    const { refreshPagination, ...payloadData } = payload
    const response = yield call(rejectOfferAPI, payloadData)
    yield put(rejectOfferSuccess(response))

    // Refresh operation offers list using pagination from payload
    const pagination = refreshPagination || {}
    try {
      const refreshResponse = yield call(getOperationOffers, {
        headers: { "input-parameters": pagination.inputParams || {} },
        pagination: { startIndex: pagination.startIndex ?? 0 },
      })
      yield put(getOperationOffersSuccess(refreshResponse))
    } catch (refreshError) {
      if (refreshError.message === "No content available") {
        yield put(getOperationOffersSuccess([]))
      } else {
        yield put(getOperationOffersFail(refreshError))
      }
    }
  } catch (error) {
    yield put(rejectOfferFail(error))
  }
}

function* onProcessOffer({ payload: { payload } }) {
  try {
    // Extract refreshPagination before API call to avoid sending it to backend
    const { refreshPagination, ...payloadData } = payload
    const response = yield call(processOfferAPI, payloadData)
    yield put(processOfferSuccess(response))

    // Refresh operation offers list using pagination from payload
    const pagination = refreshPagination || {}
    try {
      const refreshResponse = yield call(getOperationOffers, {
        headers: { "input-parameters": pagination.inputParams || {} },
        pagination: { startIndex: pagination.startIndex ?? 0 },
      })
      yield put(getOperationOffersSuccess(refreshResponse))
    } catch (refreshError) {
      if (refreshError.message === "No content available") {
        yield put(getOperationOffersSuccess([]))
      } else {
        yield put(getOperationOffersFail(refreshError))
      }
    }
  } catch (error) {
    yield put(processOfferFail(error))
  }
}

function* onPublishOffer({ payload: { payload } }) {
  try {
    // Extract refreshPagination before API call to avoid sending it to backend
    const { refreshPagination, ...payloadData } = payload
    const response = yield call(publishOfferAPI, payloadData)
    yield put(publishOfferSuccess(response))

    // Refresh approver offers list using pagination from payload
    const pagination = refreshPagination || {}
    try {
      const refreshResponse = yield call(getApproverOffers, {
        headers: { "input-parameters": pagination.inputParams || {} },
        pagination: { startIndex: pagination.startIndex ?? 0 },
      })
      yield put(getApproverOffersSuccess(refreshResponse))
    } catch (refreshError) {
      if (refreshError.message === "No content available") {
        yield put(getApproverOffersSuccess([]))
      } else {
        yield put(getApproverOffersFail(refreshError))
      }
    }
  } catch (error) {
    yield put(publishOfferFail(error))
  }
}

function* onDenyOffer({ payload: { payload } }) {
  try {
    // Extract refreshPagination before API call to avoid sending it to backend
    const { refreshPagination, ...payloadData } = payload
    const response = yield call(denyOfferAPI, payloadData)
    yield put(denyOfferSuccess(response))

    // Refresh approver offers list using pagination from payload
    const pagination = refreshPagination || {}
    try {
      const refreshResponse = yield call(getApproverOffers, {
        headers: { "input-parameters": pagination.inputParams || {} },
        pagination: { startIndex: pagination.startIndex ?? 0 },
      })
      yield put(getApproverOffersSuccess(refreshResponse))
    } catch (refreshError) {
      if (refreshError.message === "No content available") {
        yield put(getApproverOffersSuccess([]))
      } else {
        yield put(getApproverOffersFail(refreshError))
      }
    }
  } catch (error) {
    yield put(denyOfferFail(error))
  }
}

function* offersSaga() {
  yield takeEvery(GET_CURATOR_OFFERS, fetchCuratorOffers)
  yield takeEvery(MANAGE_CURATOR_OFFER, onManageCuratorOffer)
  
  yield takeEvery(GET_OPERATION_OFFERS, fetchOperationOffers)
  yield takeEvery(MANAGE_OPERATION_OFFER, onManageOperationOffer)
  
  yield takeEvery(GET_APPROVER_OFFERS, fetchApproverOffers)
  
  yield takeEvery(GET_PUBLISHED_OFFERS, fetchPublishedOffers)
  yield takeEvery(MANAGE_PUBLISHED_OFFER, onManagePublishedOffer)
  
  yield takeEvery(GET_OFFER_TAGS, fetchOfferTags)
  yield takeEvery(MANAGE_OFFER_TAG, onManageOfferTag)
  
  yield takeEvery(GET_OFFER_TAG_DEFINITIONS, fetchOfferTagDefinitions)
  
  yield takeEvery(GET_OFFER_INCLUSIONS, fetchOfferInclusions)
  yield takeEvery(MANAGE_OFFER_INCLUSIONS, onManageOfferInclusions)
  
  yield takeEvery(GET_OFFER_EXCLUSIONS, fetchOfferExclusions)
  yield takeEvery(MANAGE_OFFER_EXCLUSIONS, onManageOfferExclusions)
  
  yield takeEvery(GET_OFFER_TERMS_CONDITIONS, fetchOfferTermsConditions)
  yield takeEvery(MANAGE_OFFER_TERMS_CONDITIONS, onManageOfferTermsConditions)

  yield takeEvery(GET_OFFER_STATE_HISTORY, fetchOfferStateHistory)
  
  yield takeEvery(POST_OFFER, onPostOffer)
  yield takeEvery(REJECT_OFFER, onRejectOffer)
  yield takeEvery(PROCESS_OFFER, onProcessOffer)
  yield takeEvery(PUBLISH_OFFER, onPublishOffer)
  yield takeEvery(DENY_OFFER, onDenyOffer)
}

export default offersSaga